import { useId } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Ecomail list subscribe endpoint. A plain HTML POST with an `email` field is all it
 * needs; `source` tags the contact in Ecomail so the footer sign-ups can be told apart.
 */
const ECOMAIL_SUBSCRIBE_URL =
  'https://anderskafka.ecomailapp.cz/public/subscribe/1/43c2cd496486bcc27217c3e790fb4088?source=eshop-footer';

const NewsletterForm = () => {
  const { t } = useTranslation();
  const inputId = useId();

  return (
    <div className="footer-newsletter">
      <p className="footer-heading footer-newsletter__title fw-semibold text-uppercase mb-0">
        {t('footer.newsletter.title')}
      </p>
      <div>
        <form method="post" action={ECOMAIL_SUBSCRIBE_URL} className="footer-newsletter__form mb-2">
          <label htmlFor={inputId} className="visually-hidden">
            {t('footer.newsletter.email_label')}
          </label>
          <input
            id={inputId}
            type="email"
            name="email"
            required
            autoComplete="email"
            placeholder={t('footer.newsletter.email_placeholder')}
            className="form-control footer-newsletter__input"
          />
          <button type="submit" className="btn footer-newsletter__submit text-uppercase">
            {t('footer.newsletter.submit')}
          </button>
        </form>
        <p className="footer-newsletter__note fst-italic mb-0">{t('footer.newsletter.note')}</p>
      </div>
    </div>
  );
};

export default NewsletterForm;
